import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GestureDetector = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _gesture2 = require("./gesture");
var _reanimatedWrapper = require("./reanimatedWrapper");
var _handlersRegistry = require("../handlersRegistry");
var _RNGestureHandlerModule = _interopRequireDefault(require("../../RNGestureHandlerModule"));
var _gestureHandlerCommon = require("../gestureHandlerCommon");
var _gestureStateManager = require("./gestureStateManager");
var _FlingGestureHandler = require("../FlingGestureHandler");
var _ForceTouchGestureHandler = require("../ForceTouchGestureHandler");
var _LongPressGestureHandler = require("../LongPressGestureHandler");
var _PanGestureHandler = require("../PanGestureHandler");
var _TapGestureHandler = require("../TapGestureHandler");
var _hoverGesture = require("./hoverGesture");
var _State = require("../../State");
var _TouchEventType = require("../../TouchEventType");
var _ActionType = require("../../ActionType");
var _utils = require("../../utils");
var _getShadowNodeFromRef = require("../../getShadowNodeFromRef");
var _reactNative = require("react-native");
var _eventReceiver = require("./eventReceiver");
var _RNRenderer = require("../../RNRenderer");
var _EnableNewWebImplementation = require("../../EnableNewWebImplementation");
var _NativeViewGestureHandler = require("../NativeViewGestureHandler");
var _GestureHandlerRootViewContext = _interopRequireDefault(require("../../GestureHandlerRootViewContext"));
var _ghQueueMicrotask = require("../../ghQueueMicrotask");
var _jsxRuntime = require("react/jsx-runtime");
var _this = this, _jsxFileName = "/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx", _Reanimated$default$c, _Reanimated$default;
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var ALLOWED_PROPS = [].concat((0, _toConsumableArray2.default)(_gestureHandlerCommon.baseGestureHandlerWithMonitorProps), (0, _toConsumableArray2.default)(_TapGestureHandler.tapGestureHandlerProps), (0, _toConsumableArray2.default)(_PanGestureHandler.panGestureHandlerProps), (0, _toConsumableArray2.default)(_PanGestureHandler.panGestureHandlerCustomNativeProps), (0, _toConsumableArray2.default)(_LongPressGestureHandler.longPressGestureHandlerProps), (0, _toConsumableArray2.default)(_ForceTouchGestureHandler.forceTouchGestureHandlerProps), (0, _toConsumableArray2.default)(_FlingGestureHandler.flingGestureHandlerProps), (0, _toConsumableArray2.default)(_hoverGesture.hoverGestureHandlerProps), (0, _toConsumableArray2.default)(_NativeViewGestureHandler.nativeViewGestureHandlerProps));
function convertToHandlerTag(ref) {
    if (typeof ref === "number") {
        return ref;
    } else if (_instanceof(ref, _gesture2.BaseGesture)) {
        return ref.handlerTag;
    } else {
        var _ref$current$handlerT, _ref$current;
        return (_ref$current$handlerT = (_ref$current = ref.current) == null ? void 0 : _ref$current.handlerTag) != null ? _ref$current$handlerT : -1;
    }
}
function extractValidHandlerTags(interactionGroup) {
    var _interactionGroup$map, _interactionGroup$map2;
    return (_interactionGroup$map = interactionGroup == null ? void 0 : (_interactionGroup$map2 = interactionGroup.map(convertToHandlerTag)) == null ? void 0 : _interactionGroup$map2.filter(function(tag) {
        return tag > 0;
    })) != null ? _interactionGroup$map : [];
}
function dropHandlers(preparedGesture) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = preparedGesture.config[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            _RNGestureHandlerModule.default.dropGestureHandler(handler.handlerTag);
            (0, _handlersRegistry.unregisterHandler)(handler.handlerTag, handler.config.testId);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    (0, _gestureHandlerCommon.scheduleFlushOperations)();
}
function checkGestureCallbacksForWorklets(gesture) {
    if (gesture.config.runOnJS) {
        return;
    }
    var areSomeNotWorklets = gesture.handlers.isWorklet.includes(false);
    var areSomeWorklets = gesture.handlers.isWorklet.includes(true);
    if (areSomeNotWorklets && areSomeWorklets) {
        console.error((0, _utils.tagMessage)("Some of the callbacks in the gesture are worklets and some are not. Either make sure that all calbacks are marked as 'worklet' if you wish to run them on the UI thread or use '.runOnJS(true)' modifier on the gesture explicitly to run all callbacks on the JS thread."));
    }
}
function attachHandlers(_ref) {
    var preparedGesture = _ref.preparedGesture, gestureConfig = _ref.gestureConfig, gesture = _ref.gesture, viewTag = _ref.viewTag, webEventHandlersRef = _ref.webEventHandlersRef, mountedRef = _ref.mountedRef;
    if (!preparedGesture.firstExecution) {
        gestureConfig.initialize();
    } else {
        preparedGesture.firstExecution = false;
    }
    (0, _ghQueueMicrotask.ghQueueMicrotask)(function() {
        if (!mountedRef.current) {
            return;
        }
        gestureConfig.prepare();
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = gesture[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            checkGestureCallbacksForWorklets(handler);
            _RNGestureHandlerModule.default.createGestureHandler(handler.handlerName, handler.handlerTag, (0, _gestureHandlerCommon.filterConfig)(handler.config, ALLOWED_PROPS));
            (0, _handlersRegistry.registerHandler)(handler.handlerTag, handler, handler.config.testId);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    (0, _ghQueueMicrotask.ghQueueMicrotask)(function() {
        if (!mountedRef.current) {
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = gesture[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _handler = _step.value;
                var requireToFail = [];
                if (_handler.config.requireToFail) {
                    requireToFail = extractValidHandlerTags(_handler.config.requireToFail);
                }
                var simultaneousWith = [];
                if (_handler.config.simultaneousWith) {
                    simultaneousWith = extractValidHandlerTags(_handler.config.simultaneousWith);
                }
                _RNGestureHandlerModule.default.updateGestureHandler(_handler.handlerTag, (0, _gestureHandlerCommon.filterConfig)(_handler.config, ALLOWED_PROPS, {
                    simultaneousHandlers: simultaneousWith,
                    waitFor: requireToFail
                }));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        (0, _gestureHandlerCommon.scheduleFlushOperations)();
    });
    preparedGesture.config = gesture;
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = preparedGesture.config[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _gesture = _step1.value;
            var actionType = _gesture.shouldUseReanimated ? _ActionType.ActionType.REANIMATED_WORKLET : _ActionType.ActionType.JS_FUNCTION_NEW_API;
            if (_reactNative.Platform.OS === "web") {
                _RNGestureHandlerModule.default.attachGestureHandler(_gesture.handlerTag, viewTag, _ActionType.ActionType.JS_FUNCTION_OLD_API, webEventHandlersRef);
            } else {
                _RNGestureHandlerModule.default.attachGestureHandler(_gesture.handlerTag, viewTag, actionType);
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (preparedGesture.animatedHandlers) {
        var isAnimatedGesture = function isAnimatedGesture(g) {
            return g.shouldUseReanimated;
        };
        preparedGesture.animatedHandlers.value = gesture.filter(isAnimatedGesture).map(function(g) {
            return g.handlers;
        });
    }
}
function updateHandlers(preparedGesture, gestureConfig, gesture, mountedRef) {
    gestureConfig.prepare();
    for(var i = 0; i < gesture.length; i++){
        var handler = preparedGesture.config[i];
        checkGestureCallbacksForWorklets(handler);
        if (gesture[i].handlerTag !== handler.handlerTag) {
            gesture[i].handlerTag = handler.handlerTag;
            gesture[i].handlers.handlerTag = handler.handlerTag;
        }
    }
    (0, _ghQueueMicrotask.ghQueueMicrotask)(function() {
        if (!mountedRef.current) {
            return;
        }
        for(var _i = 0; _i < gesture.length; _i++){
            var _handler2 = preparedGesture.config[_i];
            _handler2.config = gesture[_i].config;
            _handler2.handlers = gesture[_i].handlers;
            var requireToFail = extractValidHandlerTags(_handler2.config.requireToFail);
            var simultaneousWith = extractValidHandlerTags(_handler2.config.simultaneousWith);
            _RNGestureHandlerModule.default.updateGestureHandler(_handler2.handlerTag, (0, _gestureHandlerCommon.filterConfig)(_handler2.config, ALLOWED_PROPS, {
                simultaneousHandlers: simultaneousWith,
                waitFor: requireToFail
            }));
            (0, _handlersRegistry.registerHandler)(_handler2.handlerTag, _handler2, _handler2.config.testId);
        }
        if (preparedGesture.animatedHandlers) {
            var _preparedGesture$anim;
            var previousHandlersValue = (_preparedGesture$anim = preparedGesture.animatedHandlers.value) != null ? _preparedGesture$anim : [];
            var newHandlersValue = preparedGesture.config.filter(function(g) {
                return g.shouldUseReanimated;
            }).map(function(g) {
                return g.handlers;
            });
            var shouldUpdateSharedValue = previousHandlersValue.length !== newHandlersValue.length;
            if (!shouldUpdateSharedValue) {
                for(var _i2 = 0; _i2 < newHandlersValue.length; _i2++){
                    if (newHandlersValue[_i2].gestureId !== previousHandlersValue[_i2].gestureId) {
                        shouldUpdateSharedValue = true;
                        break;
                    }
                }
            }
            if (shouldUpdateSharedValue) {
                preparedGesture.animatedHandlers.value = newHandlersValue;
            }
        }
        (0, _gestureHandlerCommon.scheduleFlushOperations)();
    });
}
function needsToReattach(preparedGesture, gesture) {
    if (gesture.length !== preparedGesture.config.length) {
        return true;
    }
    for(var i = 0; i < gesture.length; i++){
        if (gesture[i].handlerName !== preparedGesture.config[i].handlerName || gesture[i].shouldUseReanimated !== preparedGesture.config[i].shouldUseReanimated) {
            return true;
        }
    }
    return false;
}
var _worklet_13883357260557_init_data = {
    code: "function isStateChangeEvent(event){return event.oldState!=null;}",
    location: "/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx",
    sourceMap: '{"version":3,"names":["isStateChangeEvent","event","oldState"],"sources":["/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx"],"mappings":"AAkWA,SAAAA,kBAASA,CACPC,KAAA,CACD,CAGC,MAAO,CAAAA,KAAK,CAACC,QAAQ,EAAI,IAAI,CAC/B"}',
    version: "3.5.4"
};
var isStateChangeEvent = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var isStateChangeEvent = function isStateChangeEvent(event) {
        return event.oldState != null;
    };
    isStateChangeEvent.__closure = {};
    isStateChangeEvent.__initData = _worklet_13883357260557_init_data;
    isStateChangeEvent.__workletHash = 13883357260557;
    isStateChangeEvent.__stackDetails = _e;
    return isStateChangeEvent;
}();
var _worklet_15872269086045_init_data = {
    code: "function isTouchEvent(event){return event.eventType!=null;}",
    location: "/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx",
    sourceMap: '{"version":3,"names":["isTouchEvent","event","eventType"],"sources":["/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx"],"mappings":"AA0WA,SAAAA,YAASA,CACPC,KAAA,CACD,CAEC,MAAO,CAAAA,KAAK,CAACC,SAAS,EAAI,IAAI,CAChC"}',
    version: "3.5.4"
};
var isTouchEvent = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var isTouchEvent = function isTouchEvent(event) {
        return event.eventType != null;
    };
    isTouchEvent.__closure = {};
    isTouchEvent.__initData = _worklet_15872269086045_init_data;
    isTouchEvent.__workletHash = 15872269086045;
    isTouchEvent.__stackDetails = _e;
    return isTouchEvent;
}();
var _worklet_12621821362088_init_data = {
    code: "function getHandler(type,gesture){const{CALLBACK_TYPE}=this.__closure;switch(type){case CALLBACK_TYPE.BEGAN:return gesture.onBegin;case CALLBACK_TYPE.START:return gesture.onStart;case CALLBACK_TYPE.UPDATE:return gesture.onUpdate;case CALLBACK_TYPE.CHANGE:return gesture.onChange;case CALLBACK_TYPE.END:return gesture.onEnd;case CALLBACK_TYPE.FINALIZE:return gesture.onFinalize;case CALLBACK_TYPE.TOUCHES_DOWN:return gesture.onTouchesDown;case CALLBACK_TYPE.TOUCHES_MOVE:return gesture.onTouchesMove;case CALLBACK_TYPE.TOUCHES_UP:return gesture.onTouchesUp;case CALLBACK_TYPE.TOUCHES_CANCELLED:return gesture.onTouchesCancelled;}}",
    location: "/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx",
    sourceMap: '{"version":3,"names":["getHandler","type","gesture","CALLBACK_TYPE","__closure","BEGAN","onBegin","START","onStart","UPDATE","onUpdate","CHANGE","onChange","END","onEnd","FINALIZE","onFinalize","TOUCHES_DOWN","onTouchesDown","TOUCHES_MOVE","onTouchesMove","TOUCHES_UP","onTouchesUp","TOUCHES_CANCELLED","onTouchesCancelled"],"sources":["/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx"],"mappings":"AAiXA,SAAAA,UAASA,CACPC,IAAA,CAAmBC,OACnB,CAAkD,OAAAC,aAAA,OAAAC,SAAA,CAGlD,OAAQH,IAAI,EACV,IAAK,CAAAE,aAAa,CAACE,KAAK,CACtB,MAAO,CAAAH,OAAO,CAACI,OAAO,CACxB,IAAK,CAAAH,aAAa,CAACI,KAAK,CACtB,MAAO,CAAAL,OAAO,CAACM,OAAO,CACxB,IAAK,CAAAL,aAAa,CAACM,MAAM,CACvB,MAAO,CAAAP,OAAO,CAACQ,QAAQ,CACzB,IAAK,CAAAP,aAAa,CAACQ,MAAM,CACvB,MAAO,CAAAT,OAAO,CAACU,QAAQ,CACzB,IAAK,CAAAT,aAAa,CAACU,GAAG,CACpB,MAAO,CAAAX,OAAO,CAACY,KAAK,CACtB,IAAK,CAAAX,aAAa,CAACY,QAAQ,CACzB,MAAO,CAAAb,OAAO,CAACc,UAAU,CAC3B,IAAK,CAAAb,aAAa,CAACc,YAAY,CAC7B,MAAO,CAAAf,OAAO,CAACgB,aAAa,CAC9B,IAAK,CAAAf,aAAa,CAACgB,YAAY,CAC7B,MAAO,CAAAjB,OAAO,CAACkB,aAAa,CAC9B,IAAK,CAAAjB,aAAa,CAACkB,UAAU,CAC3B,MAAO,CAAAnB,OAAO,CAACoB,WAAW,CAC5B,IAAK,CAAAnB,aAAa,CAACoB,iBAAiB,CAClC,MAAO,CAAArB,OAAO,CAACsB,kBAAkB,CACrC,CACF"}',
    version: "3.5.4"
};
var getHandler = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var getHandler = function getHandler(type, gesture) {
        switch(type){
            case _gesture2.CALLBACK_TYPE.BEGAN:
                return gesture.onBegin;
            case _gesture2.CALLBACK_TYPE.START:
                return gesture.onStart;
            case _gesture2.CALLBACK_TYPE.UPDATE:
                return gesture.onUpdate;
            case _gesture2.CALLBACK_TYPE.CHANGE:
                return gesture.onChange;
            case _gesture2.CALLBACK_TYPE.END:
                return gesture.onEnd;
            case _gesture2.CALLBACK_TYPE.FINALIZE:
                return gesture.onFinalize;
            case _gesture2.CALLBACK_TYPE.TOUCHES_DOWN:
                return gesture.onTouchesDown;
            case _gesture2.CALLBACK_TYPE.TOUCHES_MOVE:
                return gesture.onTouchesMove;
            case _gesture2.CALLBACK_TYPE.TOUCHES_UP:
                return gesture.onTouchesUp;
            case _gesture2.CALLBACK_TYPE.TOUCHES_CANCELLED:
                return gesture.onTouchesCancelled;
        }
    };
    getHandler.__closure = {
        CALLBACK_TYPE: _gesture2.CALLBACK_TYPE
    };
    getHandler.__initData = _worklet_12621821362088_init_data;
    getHandler.__workletHash = 12621821362088;
    getHandler.__stackDetails = _e;
    return getHandler;
}();
var _worklet_3914047291176_init_data = {
    code: "function touchEventTypeToCallbackType(eventType){const{TouchEventType,CALLBACK_TYPE}=this.__closure;switch(eventType){case TouchEventType.TOUCHES_DOWN:return CALLBACK_TYPE.TOUCHES_DOWN;case TouchEventType.TOUCHES_MOVE:return CALLBACK_TYPE.TOUCHES_MOVE;case TouchEventType.TOUCHES_UP:return CALLBACK_TYPE.TOUCHES_UP;case TouchEventType.TOUCHES_CANCELLED:return CALLBACK_TYPE.TOUCHES_CANCELLED;}return CALLBACK_TYPE.UNDEFINED;}",
    location: "/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx",
    sourceMap: '{"version":3,"names":["touchEventTypeToCallbackType","eventType","TouchEventType","CALLBACK_TYPE","__closure","TOUCHES_DOWN","TOUCHES_MOVE","TOUCHES_UP","TOUCHES_CANCELLED","UNDEFINED"],"sources":["/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx"],"mappings":"AA8YA,SAAAA,4BAASA,CACPC,SAAA,CACD,OAAAC,cAAA,CAAAC,aAAA,OAAAC,SAAA,CAEC,OAAQH,SAAS,EACf,IAAK,CAAAC,cAAc,CAACG,YAAY,CAC9B,MAAO,CAAAF,aAAa,CAACE,YAAY,CACnC,IAAK,CAAAH,cAAc,CAACI,YAAY,CAC9B,MAAO,CAAAH,aAAa,CAACG,YAAY,CACnC,IAAK,CAAAJ,cAAc,CAACK,UAAU,CAC5B,MAAO,CAAAJ,aAAa,CAACI,UAAU,CACjC,IAAK,CAAAL,cAAc,CAACM,iBAAiB,CACnC,MAAO,CAAAL,aAAa,CAACK,iBAAiB,CAC1C,CACA,MAAO,CAAAL,aAAa,CAACM,SAAS,CAChC"}',
    version: "3.5.4"
};
var touchEventTypeToCallbackType = function() {
    var _e = [
        new global.Error(),
        -3,
        -27
    ];
    var touchEventTypeToCallbackType = function touchEventTypeToCallbackType(eventType) {
        switch(eventType){
            case _TouchEventType.TouchEventType.TOUCHES_DOWN:
                return _gesture2.CALLBACK_TYPE.TOUCHES_DOWN;
            case _TouchEventType.TouchEventType.TOUCHES_MOVE:
                return _gesture2.CALLBACK_TYPE.TOUCHES_MOVE;
            case _TouchEventType.TouchEventType.TOUCHES_UP:
                return _gesture2.CALLBACK_TYPE.TOUCHES_UP;
            case _TouchEventType.TouchEventType.TOUCHES_CANCELLED:
                return _gesture2.CALLBACK_TYPE.TOUCHES_CANCELLED;
        }
        return _gesture2.CALLBACK_TYPE.UNDEFINED;
    };
    touchEventTypeToCallbackType.__closure = {
        TouchEventType: _TouchEventType.TouchEventType,
        CALLBACK_TYPE: _gesture2.CALLBACK_TYPE
    };
    touchEventTypeToCallbackType.__initData = _worklet_3914047291176_init_data;
    touchEventTypeToCallbackType.__workletHash = 3914047291176;
    touchEventTypeToCallbackType.__stackDetails = _e;
    return touchEventTypeToCallbackType;
}();
var _worklet_6944867991815_init_data = {
    code: "function runWorklet(type,gesture,event,...args){const{getHandler,tagMessage}=this.__closure;const handler=getHandler(type,gesture);if(gesture.isWorklet[type]){handler===null||handler===void 0?void 0:handler(event,...args);}else if(handler){console.warn(tagMessage('Animated gesture callback must be a worklet'));}}",
    location: "/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx",
    sourceMap: '{"version":3,"names":["runWorklet","type","gesture","event","args","getHandler","tagMessage","__closure","handler","isWorklet","console","warn"],"sources":["/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx"],"mappings":"AA+ZA,SAAAA,UAASA,CACPC,IAAA,CAAmBC,OACnB,CAAkDC,KAClD,CAAuE,GACvEC,IAAG,CAAW,OAAAC,UAAA,CAAAC,UAAA,OAAAC,SAAA,CAGd,KAAM,CAAAC,OAAO,CAAGH,UAAU,CAACJ,IAAI,CAAEC,OAAO,CAAC,CACzC,GAAIA,OAAO,CAACO,SAAS,CAACR,IAAI,CAAC,CAAE,CAG3BO,OAAO,SAAPA,OAAO,iBAAPA,OAAO,CAAGL,KAAK,CAAE,GAAGC,IAAI,CAAC,CAC3B,CAAC,IAAM,IAAII,OAAO,CAAE,CAClBE,OAAO,CAACC,IAAI,CAACL,UAAU,CAAC,6CAA6C,CAAC,CAAC,CACzE,CACF"}',
    version: "3.5.4"
};
var runWorklet = function() {
    var _e = [
        new global.Error(),
        -3,
        -27
    ];
    var runWorklet = function runWorklet(type, gesture, event) {
        var handler = getHandler(type, gesture);
        if (gesture.isWorklet[type]) {
            for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
                args[_key - 3] = arguments[_key];
            }
            handler == null ? void 0 : handler.apply(void 0, [
                event
            ].concat(args));
        } else if (handler) {
            console.warn((0, _utils.tagMessage)("Animated gesture callback must be a worklet"));
        }
    };
    runWorklet.__closure = {
        getHandler: getHandler,
        tagMessage: _utils.tagMessage
    };
    runWorklet.__initData = _worklet_6944867991815_init_data;
    runWorklet.__workletHash = 6944867991815;
    runWorklet.__stackDetails = _e;
    return runWorklet;
}();
var _worklet_14213353093337_init_data = {
    code: "function anonymous(event){const{sharedHandlersCallbacks,isStateChangeEvent,State,runWorklet,CALLBACK_TYPE,lastUpdateEvent,isTouchEvent,stateControllers,GestureStateManager,TouchEventType,touchEventTypeToCallbackType}=this.__closure;const currentCallback=sharedHandlersCallbacks.value;if(!currentCallback){return;}for(let i=0;i<currentCallback.length;i++){const gesture=currentCallback[i];if(event.handlerTag===gesture.handlerTag){if(isStateChangeEvent(event)){if(event.oldState===State.UNDETERMINED&&event.state===State.BEGAN){runWorklet(CALLBACK_TYPE.BEGAN,gesture,event);}else if((event.oldState===State.BEGAN||event.oldState===State.UNDETERMINED)&&event.state===State.ACTIVE){runWorklet(CALLBACK_TYPE.START,gesture,event);lastUpdateEvent.value[gesture.handlerTag]=undefined;}else if(event.oldState!==event.state&&event.state===State.END){if(event.oldState===State.ACTIVE){runWorklet(CALLBACK_TYPE.END,gesture,event,true);}runWorklet(CALLBACK_TYPE.FINALIZE,gesture,event,true);}else if((event.state===State.FAILED||event.state===State.CANCELLED)&&event.state!==event.oldState){if(event.oldState===State.ACTIVE){runWorklet(CALLBACK_TYPE.END,gesture,event,false);}runWorklet(CALLBACK_TYPE.FINALIZE,gesture,event,false);}}else if(isTouchEvent(event)){if(!stateControllers[i]){stateControllers[i]=GestureStateManager.create(event.handlerTag);}if(event.eventType!==TouchEventType.UNDETERMINED){runWorklet(touchEventTypeToCallbackType(event.eventType),gesture,event,stateControllers[i]);}}else{runWorklet(CALLBACK_TYPE.UPDATE,gesture,event);if(gesture.onChange&&gesture.changeEventCalculator){var _gesture$changeEventC;runWorklet(CALLBACK_TYPE.CHANGE,gesture,(_gesture$changeEventC=gesture.changeEventCalculator)===null||_gesture$changeEventC===void 0?void 0:_gesture$changeEventC.call(gesture,event,lastUpdateEvent.value[gesture.handlerTag]));lastUpdateEvent.value[gesture.handlerTag]=event;}}}}}",
    location: "/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx",
    sourceMap: '{"version":3,"names":["anonymous","event","sharedHandlersCallbacks","isStateChangeEvent","State","runWorklet","CALLBACK_TYPE","lastUpdateEvent","isTouchEvent","stateControllers","GestureStateManager","TouchEventType","touchEventTypeToCallbackType","__closure","currentCallback","value","i","length","gesture","handlerTag","oldState","UNDETERMINED","state","BEGAN","ACTIVE","START","undefined","END","FINALIZE","FAILED","CANCELLED","create","eventType","UPDATE","onChange","changeEventCalculator","_gesture$changeEventC","CHANGE","call"],"sources":["/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/GestureDetector.tsx"],"mappings":"AAucmB,QACf,CAAAA,SACGA,CAAAC,KAAA,QAAAC,uBAAA,CAAAC,kBAAA,CAAAC,KAAA,CAAAC,UAAA,CAAAC,aAAA,CAAAC,eAAA,CAAAC,YAAA,CAAAC,gBAAA,CAAAC,mBAAA,CAAAC,cAAA,CAAAC,4BAAA,OAAAC,SAAA,CAGH,KAAM,CAAAC,eAAe,CAAGZ,uBAAuB,CAACa,KAAK,CACrD,GAAI,CAACD,eAAe,CAAE,CACpB,OACF,CAEA,IAAK,GAAI,CAAAE,CAAC,CAAG,CAAC,CAAEA,CAAC,CAAGF,eAAe,CAACG,MAAM,CAAED,CAAC,EAAE,CAAE,CAC/C,KAAM,CAAAE,OAAO,CAAGJ,eAAe,CAACE,CAAC,CAAC,CAElC,GAAIf,KAAK,CAACkB,UAAU,GAAKD,OAAO,CAACC,UAAU,CAAE,CAC3C,GAAIhB,kBAAkB,CAACF,KAAK,CAAC,CAAE,CAC7B,GACEA,KAAK,CAACmB,QAAQ,GAAKhB,KAAK,CAACiB,YAAY,EACrCpB,KAAK,CAACqB,KAAK,GAAKlB,KAAK,CAACmB,KAAK,CAC3B,CACAlB,UAAU,CAACC,aAAa,CAACiB,KAAK,CAAEL,OAAO,CAAEjB,KAAK,CAAC,CACjD,CAAC,IAAM,IACL,CAACA,KAAK,CAACmB,QAAQ,GAAKhB,KAAK,CAACmB,KAAK,EAC7BtB,KAAK,CAACmB,QAAQ,GAAKhB,KAAK,CAACiB,YAAY,GACvCpB,KAAK,CAACqB,KAAK,GAAKlB,KAAK,CAACoB,MAAM,CAC5B,CACAnB,UAAU,CAACC,aAAa,CAACmB,KAAK,CAAEP,OAAO,CAAEjB,KAAK,CAAC,CAC/CM,eAAe,CAACQ,KAAK,CAACG,OAAO,CAACC,UAAU,CAAC,CAAGO,SAAS,CACvD,CAAC,IAAM,IACLzB,KAAK,CAACmB,QAAQ,GAAKnB,KAAK,CAACqB,KAAK,EAC9BrB,KAAK,CAACqB,KAAK,GAAKlB,KAAK,CAACuB,GAAG,CACzB,CACA,GAAI1B,KAAK,CAACmB,QAAQ,GAAKhB,KAAK,CAACoB,MAAM,CAAE,CACnCnB,UAAU,CAACC,aAAa,CAACqB,GAAG,CAAET,OAAO,CAAEjB,KAAK,CAAE,IAAI,CAAC,CACrD,CACAI,UAAU,CAACC,aAAa,CAACsB,QAAQ,CAAEV,OAAO,CAAEjB,KAAK,CAAE,IAAI,CAAC,CAC1D,CAAC,IAAM,IACL,CAACA,KAAK,CAACqB,KAAK,GAAKlB,KAAK,CAACyB,MAAM,EAAI5B,KAAK,CAACqB,KAAK,GAAKlB,KAAK,CAAC0B,SAAS,GAChE7B,KAAK,CAACqB,KAAK,GAAKrB,KAAK,CAACmB,QAAQ,CAC9B,CACA,GAAInB,KAAK,CAACmB,QAAQ,GAAKhB,KAAK,CAACoB,MAAM,CAAE,CACnCnB,UAAU,CAACC,aAAa,CAACqB,GAAG,CAAET,OAAO,CAAEjB,KAAK,CAAE,KAAK,CAAC,CACtD,CACAI,UAAU,CAACC,aAAa,CAACsB,QAAQ,CAAEV,OAAO,CAAEjB,KAAK,CAAE,KAAK,CAAC,CAC3D,CACF,CAAC,IAAM,IAAIO,YAAY,CAACP,KAAK,CAAC,CAAE,CAC9B,GAAI,CAACQ,gBAAgB,CAACO,CAAC,CAAC,CAAE,CACxBP,gBAAgB,CAACO,CAAC,CAAC,CAAGN,mBAAmB,CAACqB,MAAM,CAAC9B,KAAK,CAACkB,UAAU,CAAC,CACpE,CAEA,GAAIlB,KAAK,CAAC+B,SAAS,GAAKrB,cAAc,CAACU,YAAY,CAAE,CACnDhB,UAAU,CACRO,4BAA4B,CAACX,KAAK,CAAC+B,SAAS,CAAC,CAC7Cd,OAAO,CACPjB,KAAK,CACLQ,gBAAgB,CAACO,CAAC,CACpB,CAAC,CACH,CACF,CAAC,IAAM,CACLX,UAAU,CAACC,aAAa,CAAC2B,MAAM,CAAEf,OAAO,CAAEjB,KAAK,CAAC,CAEhD,GAAIiB,OAAO,CAACgB,QAAQ,EAAIhB,OAAO,CAACiB,qBAAqB,CAAE,KAAAC,qBAAA,CACrD/B,UAAU,CACRC,aAAa,CAAC+B,MAAM,CACpBnB,OAAO,EAAAkB,qBAAA,CACPlB,OAAO,CAACiB,qBAAqB,UAAAC,qBAAA,iBAA7BA,qBAAA,CAAAE,IAAA,CAAApB,OAAO,CACLjB,KAAK,CACLM,eAAe,CAACQ,KAAK,CAACG,OAAO,CAACC,UAAU,CAC1C,CACF,CAAC,CAEDZ,eAAe,CAACQ,KAAK,CAACG,OAAO,CAACC,UAAU,CAAC,CAAGlB,KAAK,CACnD,CACF,CACF,CACF,CACF"}',
    version: "3.5.4"
};
function useAnimatedGesture(preparedGesture, needsRebuild) {
    if (!_reanimatedWrapper.Reanimated) {
        return;
    }
    var sharedHandlersCallbacks = _reanimatedWrapper.Reanimated.useSharedValue(null);
    var lastUpdateEvent = _reanimatedWrapper.Reanimated.useSharedValue([]);
    var stateControllers = [];
    var callback = function() {
        var _e = [
            new global.Error(),
            -12,
            -27
        ];
        var anonymous = function anonymous(event) {
            var currentCallback = sharedHandlersCallbacks.value;
            if (!currentCallback) {
                return;
            }
            for(var i = 0; i < currentCallback.length; i++){
                var gesture = currentCallback[i];
                if (event.handlerTag === gesture.handlerTag) {
                    if (isStateChangeEvent(event)) {
                        if (event.oldState === _State.State.UNDETERMINED && event.state === _State.State.BEGAN) {
                            runWorklet(_gesture2.CALLBACK_TYPE.BEGAN, gesture, event);
                        } else if ((event.oldState === _State.State.BEGAN || event.oldState === _State.State.UNDETERMINED) && event.state === _State.State.ACTIVE) {
                            runWorklet(_gesture2.CALLBACK_TYPE.START, gesture, event);
                            lastUpdateEvent.value[gesture.handlerTag] = undefined;
                        } else if (event.oldState !== event.state && event.state === _State.State.END) {
                            if (event.oldState === _State.State.ACTIVE) {
                                runWorklet(_gesture2.CALLBACK_TYPE.END, gesture, event, true);
                            }
                            runWorklet(_gesture2.CALLBACK_TYPE.FINALIZE, gesture, event, true);
                        } else if ((event.state === _State.State.FAILED || event.state === _State.State.CANCELLED) && event.state !== event.oldState) {
                            if (event.oldState === _State.State.ACTIVE) {
                                runWorklet(_gesture2.CALLBACK_TYPE.END, gesture, event, false);
                            }
                            runWorklet(_gesture2.CALLBACK_TYPE.FINALIZE, gesture, event, false);
                        }
                    } else if (isTouchEvent(event)) {
                        if (!stateControllers[i]) {
                            stateControllers[i] = _gestureStateManager.GestureStateManager.create(event.handlerTag);
                        }
                        if (event.eventType !== _TouchEventType.TouchEventType.UNDETERMINED) {
                            runWorklet(touchEventTypeToCallbackType(event.eventType), gesture, event, stateControllers[i]);
                        }
                    } else {
                        runWorklet(_gesture2.CALLBACK_TYPE.UPDATE, gesture, event);
                        if (gesture.onChange && gesture.changeEventCalculator) {
                            runWorklet(_gesture2.CALLBACK_TYPE.CHANGE, gesture, gesture.changeEventCalculator == null ? void 0 : gesture.changeEventCalculator(event, lastUpdateEvent.value[gesture.handlerTag]));
                            lastUpdateEvent.value[gesture.handlerTag] = event;
                        }
                    }
                }
            }
        };
        anonymous.__closure = {
            sharedHandlersCallbacks: sharedHandlersCallbacks,
            isStateChangeEvent: isStateChangeEvent,
            State: _State.State,
            runWorklet: runWorklet,
            CALLBACK_TYPE: _gesture2.CALLBACK_TYPE,
            lastUpdateEvent: lastUpdateEvent,
            isTouchEvent: isTouchEvent,
            stateControllers: stateControllers,
            GestureStateManager: _gestureStateManager.GestureStateManager,
            TouchEventType: _TouchEventType.TouchEventType,
            touchEventTypeToCallbackType: touchEventTypeToCallbackType
        };
        anonymous.__initData = _worklet_14213353093337_init_data;
        anonymous.__workletHash = 14213353093337;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
    var event = _reanimatedWrapper.Reanimated.useEvent(callback, [
        "onGestureHandlerStateChange",
        "onGestureHandlerEvent"
    ], needsRebuild);
    preparedGesture.animatedEventHandler = event;
    preparedGesture.animatedHandlers = sharedHandlersCallbacks;
}
function validateDetectorChildren(ref) {
    if (__DEV__ && _reactNative.Platform.OS !== "web") {
        var wrapType = _utils.REACT_NATIVE_VERSION.minor > 63 || _utils.REACT_NATIVE_VERSION.major > 0 ? ref._reactInternals.elementType : ref._reactInternalFiber.elementType;
        var instance = _RNRenderer.RNRenderer.findHostInstance_DEPRECATED(ref)._internalFiberInstanceHandleDEV;
        while(instance && instance.elementType !== wrapType){
            if (instance.sibling) {
                throw new Error("GestureDetector has more than one native view as its children. This can happen if you are using a custom component that renders multiple views, like React.Fragment. You should wrap content of GestureDetector with a <View> or <Animated.View>.");
            }
            instance = instance.return;
        }
    }
}
var applyUserSelectProp = function applyUserSelectProp(userSelect, gesture) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = gesture.toGestureArray()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var g = _step.value;
            g.config.userSelect = userSelect;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var GestureDetector = exports.GestureDetector = function GestureDetector(props) {
    var rootViewContext = (0, _react.useContext)(_GestureHandlerRootViewContext.default);
    if (__DEV__ && !rootViewContext && !(0, _utils.isJestEnv)() && _reactNative.Platform.OS !== "web") {
        throw new Error("GestureDetector must be used as a descendant of GestureHandlerRootView. Otherwise the gestures will not be recognized. See https://docs.swmansion.com/react-native-gesture-handler/docs/installation for more details.");
    }
    var gestureConfig = props.gesture;
    if (props.userSelect) {
        applyUserSelectProp(props.userSelect, gestureConfig);
    }
    var gesture = gestureConfig.toGestureArray();
    var useReanimatedHook = gesture.some(function(g) {
        return g.shouldUseReanimated;
    });
    var state = (0, _react.useRef)({
        firstRender: true,
        viewRef: null,
        previousViewTag: -1,
        forceReattach: false
    }).current;
    var mountedRef = (0, _react.useRef)(false);
    var webEventHandlersRef = (0, _react.useRef)({
        onGestureHandlerEvent: function onGestureHandlerEvent(e) {
            (0, _eventReceiver.onGestureHandlerEvent)(e.nativeEvent);
        },
        onGestureHandlerStateChange: (0, _EnableNewWebImplementation.isNewWebImplementationEnabled)() ? function(e) {
            (0, _eventReceiver.onGestureHandlerEvent)(e.nativeEvent);
        } : undefined
    });
    var _useState = (0, _react.useState)(false), _useState2 = (0, _slicedToArray2.default)(_useState, 2), renderState = _useState2[0], setRenderState = _useState2[1];
    function forceRender() {
        setRenderState(!renderState);
    }
    var preparedGesture = _react.default.useRef({
        config: gesture,
        animatedEventHandler: null,
        animatedHandlers: null,
        firstExecution: true,
        useReanimatedHook: useReanimatedHook
    }).current;
    if (useReanimatedHook !== preparedGesture.useReanimatedHook) {
        throw new Error((0, _utils.tagMessage)("You cannot change the thread the callbacks are ran on while the app is running"));
    }
    function onHandlersUpdate(skipConfigUpdate) {
        var viewTag = (0, _gestureHandlerCommon.findNodeHandle)(state.viewRef);
        var forceReattach = viewTag !== state.previousViewTag;
        if (forceReattach || needsToReattach(preparedGesture, gesture)) {
            validateDetectorChildren(state.viewRef);
            dropHandlers(preparedGesture);
            attachHandlers({
                preparedGesture: preparedGesture,
                gestureConfig: gestureConfig,
                gesture: gesture,
                webEventHandlersRef: webEventHandlersRef,
                viewTag: viewTag,
                mountedRef: mountedRef
            });
            state.previousViewTag = viewTag;
            state.forceReattach = forceReattach;
            if (forceReattach) {
                forceRender();
            }
        } else if (!skipConfigUpdate) {
            updateHandlers(preparedGesture, gestureConfig, gesture, mountedRef);
        }
    }
    var needsToRebuildReanimatedEvent = preparedGesture.firstExecution || needsToReattach(preparedGesture, gesture) || state.forceReattach;
    state.forceReattach = false;
    if (preparedGesture.firstExecution) {
        gestureConfig.initialize();
    }
    if (useReanimatedHook) {
        useAnimatedGesture(preparedGesture, needsToRebuildReanimatedEvent);
    }
    (0, _react.useEffect)(function() {
        var viewTag = (0, _gestureHandlerCommon.findNodeHandle)(state.viewRef);
        state.firstRender = true;
        mountedRef.current = true;
        validateDetectorChildren(state.viewRef);
        attachHandlers({
            preparedGesture: preparedGesture,
            gestureConfig: gestureConfig,
            gesture: gesture,
            webEventHandlersRef: webEventHandlersRef,
            viewTag: viewTag,
            mountedRef: mountedRef
        });
        return function() {
            mountedRef.current = false;
            dropHandlers(preparedGesture);
        };
    }, []);
    (0, _react.useEffect)(function() {
        if (!state.firstRender) {
            onHandlersUpdate();
        } else {
            state.firstRender = false;
        }
    }, [
        props
    ]);
    var refFunction = function refFunction(ref) {
        if (ref !== null) {
            state.viewRef = ref;
            if (state.previousViewTag === -1) {
                state.previousViewTag = (0, _gestureHandlerCommon.findNodeHandle)(state.viewRef);
            }
            onHandlersUpdate(true);
            if ((0, _utils.isFabric)()) {
                var _node = (0, _getShadowNodeFromRef.getShadowNodeFromRef)(ref);
                if (global.isFormsStackingContext(_node) === false) {
                    console.error((0, _utils.tagMessage)("GestureDetector has received a child that may get view-flattened. " + "\nTo prevent it from misbehaving you need to wrap the child with a `<View collapsable={false}>`."));
                }
            }
        }
    };
    if (useReanimatedHook) {
        return (0, _jsxRuntime.jsx)(AnimatedWrap, {
            ref: refFunction,
            onGestureHandlerEvent: preparedGesture.animatedEventHandler,
            children: props.children
        });
    } else {
        return (0, _jsxRuntime.jsx)(Wrap, {
            ref: refFunction,
            children: props.children
        });
    }
};
var Wrap = function(_React$Component) {
    (0, _inherits2.default)(Wrap, _React$Component);
    var _super = _createSuper(Wrap);
    function Wrap() {
        (0, _classCallCheck2.default)(this, Wrap);
        return _super.apply(this, arguments);
    }
    (0, _createClass2.default)(Wrap, [
        {
            key: "render",
            value: function render() {
                try {
                    var child = _react.default.Children.only(this.props.children);
                    return _react.default.cloneElement(child, {
                        collapsable: false
                    }, child.props.children);
                } catch (e) {
                    throw new Error((0, _utils.tagMessage)("GestureDetector got more than one view as a child. If you want the gesture to work on multiple views, wrap them with a common parent and attach the gesture to that view."));
                }
            }
        }
    ]);
    return Wrap;
}(_react.default.Component);
var AnimatedWrap = (_Reanimated$default$c = _reanimatedWrapper.Reanimated == null ? void 0 : (_Reanimated$default = _reanimatedWrapper.Reanimated.default) == null ? void 0 : _Reanimated$default.createAnimatedComponent(Wrap)) != null ? _Reanimated$default$c : Wrap;
